import React from 'react';
import { Container, Navbar, Nav } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import '../main.css';
import MainHomeNav from './MainHomeNav';
import HHlogo from '../HHlogo.png';

function Admissions() {
  const containerStyle = {
    backgroundColor: '#e0f4ff', // Light blue background
    minHeight: '100vh',
    padding: '60px 20px',
    color: '#003049',
    textAlign: 'center',
  };

  const headingStyle = {
    fontSize: '2.5rem',
    fontWeight: 'bold',
    marginBottom: '30px',
  };

  const paragraphStyle = {
    fontSize: '1.2rem',
    maxWidth: '800px',
    margin: '0 auto',
    lineHeight: '1.8',
    backgroundColor: '#ffffff',
    padding: '30px',
    borderRadius: '12px',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
  };

  return (
    <div>
      {/* Top Navbar (copied from MainHome) */}
      <Navbar expand="lg" variant="dark" style={{ backgroundColor: '#249ebdff' }}>
        <Container>
          <Navbar.Brand as={NavLink} to="/" className="d-flex align-items-center">
            <img
              src={HHlogo}
              alt="HHL Logo"
              className="navbar-logo d-inline-block align-top me-2"
              style={{ height: '40px', cursor: 'pointer' }}
            />
            HIGHLANDS
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">
              <NavLink to="/primary-school" className="nav-link">PRIMARY SCHOOL</NavLink>
              <NavLink to="/high-school" className="nav-link">HIGH SCHOOL</NavLink>
              <NavLink to="/admission" className="nav-link">ADMISSIONS</NavLink>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      {/* Page Content */}
      <div style={containerStyle}>
        <h1 style={headingStyle}>Admissions Are Now Open!</h1>
        <p style={paragraphStyle}>
          If you would like to enroll your child at Highlands, we welcome you to visit our campus for an admissions interview.
          <br /><br />
          🕗 <strong>Interview Hours:</strong> Saturdays, <strong>8:00 AM – 12:00 PM</strong>
          <br /><br />
          📍 Please bring your child along and visit us at Highlands College for a face-to-face session. We look forward to meeting you!
          <br /><br />
           Please note a your child may be required to write an entrance exam for HIGH SCHOOL
          <br /><br />
          ❤️ Building futures, one learner at a time.
        </p>
      </div>

      {/* Bottom Navigation / Footer */}
      <MainHomeNav />
    </div>
  );
}

export default Admissions;
